import script from "./container-nav.vue?vue&type=script&lang=ts&setup=true"
export * from "./container-nav.vue?vue&type=script&lang=ts&setup=true"

import "./container-nav.vue?vue&type=style&index=0&id=efab7e64&scoped=true&lang=stylus"
import "./container-nav.vue?vue&type=style&index=1&id=efab7e64&lang=css"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efab7e64"]])

export default __exports__